// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "recommendations-" + chunkId + ".js?v=" + {"node_modules_nextcloud_vue_dist_Components_NcColorPicker_mjs":"73ebb767b0a70712eeca","node_modules_nextcloud_vue_dist_Components_NcSelect_mjs":"c54c0616f04a0571740c","vendors-node_modules_rehype-highlight_index_js":"70a4778e6219bb956045"}[chunkId] + "";
};